import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export interface AppStoreState {
  isLiveDataEnabled: boolean;
  setIsLiveDataEnabled: (value: boolean) => void;
}

export const useAppStore = create(
  persist<AppStoreState>(
    set => ({
      isLiveDataEnabled: true,
      setIsLiveDataEnabled: isLiveDataEnabled => set({ isLiveDataEnabled }),
    }),
    {
      name: 'virtual-evse-app-data',
    },
  ),
);
